import React from 'react'

function EmptyWishlist() {
    return (
        <div style={{ marginTop: "10rem" }}>
            <span style={{ fontSize: "3rem", fontWeight: "bolder" }}>
                Your Wishlist is Empty
            </span>
        </div>
    )
}

export default EmptyWishlist